import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { useAppointmentStore } from "../../stores/useAppointmentStore";

const AppointmentDetailDialog = ({ open, onClose, appointment }) => {
  const { updateAppointment, setToastOpen } = useAppointmentStore();

  const handleComplete = () => {
    updateAppointment(appointment._id, { status: "Completed" });
    onClose();
  };

  const handleCancel = () => {
    updateAppointment(appointment._id, { status: "Cancelled" });
    onClose();
  };

  if (!appointment) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Appointment Details</DialogTitle>
      <DialogContent dividers>
        <Typography variant="subtitle1">
          Patient: {appointment.patient}
        </Typography>
        <Typography>Date: {appointment.slotDate}</Typography>
        <Typography>Time: {appointment.slot}</Typography>
        <TextField
          margin="dense"
          label="Resolution / Comments"
          multiline
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="error">
          Cancel Appointment
        </Button>
        <Button onClick={handleComplete} variant="contained">
          Mark as Complete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppointmentDetailDialog;
